import React, { FC } from "react";

import { ClickableLinkPlugin } from "@lexical/react/LexicalClickableLinkPlugin";
import { LinkPlugin as LexicalLinkPlugin } from "@lexical/react/LexicalLinkPlugin";

export const LinkPlugin: FC = () => {
  const validateUrl = (url: string): boolean => {
    // 基本的なURL検証
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  };

  return (
    <>
      <LexicalLinkPlugin validateUrl={validateUrl} />
      <ClickableLinkPlugin />
    </>
  );
};
